export class CallIdBase {
    FCT;
    constructor(FCT) {
        this.FCT = FCT;
    }
}
//# sourceMappingURL=CallIdBase.js.map